import { Center, Container, Group, Text } from "@mantine/core";
import React from "react";
import { useEffect } from "react";
import jwt_decode from "jwt-decode";
import routeNames from "../../routes/routeNames";
import { showNotification } from "@mantine/notifications";
import { useNavigate } from "react-router-dom";
import { backendUrl } from "../../constants";
import { userTypes } from "../../AdminPages/Users/userTypes";

function GoogleSignIn({ type }) {
  const navigate = useNavigate();
  function handleCallbackResponse(response) {
    console.log(response);
    console.log("Encoded JWT ID TOKEN: ", response.credential);
    let decoded = jwt_decode(response.credential);
    let signUpData = {
      firstName: decoded.given_name,
      lastName: decoded.family_name,
      email: decoded.email,
      googleId: decoded.sub,
      role: type,
      jobSeekerProfileImage:
        userTypes["Job Seekers"] === type ? decoded.picture : null,
    };
    let signInData = {
      email: decoded.email,
      googleId: decoded.sub,
    };
    if (type === "signin") {
      handleGoogleSignIn(signInData);
    } else {
      handleGoogleSignUp(signUpData);
    }
  }

  function handleGoogleSignUp(data) {
    console.log("GOOGLE SIGN UP DATA: ", data);
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(`${backendUrl}user/googleSignUp`, options)
      // fetch(`${backendUrl}user/addUser`, options)
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        //   response?.data &&
        //     localStorage.setItem("userData", JSON.stringify(response.data));
        //   if (
        //     response.data.role === "Company" ||
        //     response.data.role === "employee"
        //   ) {
        //     showNotification({
        //       title: "Google Sign Up Successful ",
        //       message: "You are logged in as Company",
        //       color: "green",
        //     });
        //     navigate(routeNames.employer.dashboard);
        //     window.location.reload();
        //   } else if (response.data.role === "JobSeeker") {
        //     showNotification({
        //       title: "Google Sign Up Successful",
        //       message: "You are logged in as Job Seeker",
        //       color: "green",
        //     });
        //     navigate(routeNames.jobSeeker.dashboard);
        //     window.location.reload();
        //   }
        if (response.status) {
          showNotification({
            title: "Success",
            message: "You have successfully registered",
            color: "teal",
          });
          navigate(routeNames.general.login);
        } else {
          // also check if user is already signed in and is google user as well
          if (response.message === "User with same email already exist") {
            console.log("User with same email already exist");
            handleGoogleSignIn(
              { email: data.email, googleId: data.googleId },
              true
            );
          } else {
            showNotification({
              title: "Error",
              message: response.message,
              color: "red",
            });
          }
        }
      })
      .catch((err) => console.error(err));
  }

  function handleGoogleSignIn(data, redirected = false) {
    console.log("GOOGLE SIGN IN DATA", data);
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(`${backendUrl}user/googleSignIn`, options)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          response?.data &&
            localStorage.setItem("userData", JSON.stringify(response.data));
          if (
            response.data?.role === "Company" ||
            response.data?.role === "employee"
          ) {
            navigate(routeNames.employer.dashboard);
            window.location.reload();
          } else if (response.data.role === "JobSeeker") {
            navigate(routeNames.jobSeeker.homeFeed);
            window.location.reload();
          } else if (response.data.role === "Admin") {
            showNotification({
              title: "Welcome Admin",
              message: "You are logged in as Admin",
              color: "green",
            });
            navigate(routeNames.admin.dashboard);
          }
        } else {
          if (response.message === "User is inactive") {
            showNotification({
              title: "ACCOUNT BLOCKED. NEEDS TO BE VERIFIED BY ADMIN",
              message: "Please wait for Admin to verify and activate your account",
              color: "red",
            });
          } else {
            showNotification({
              title: "Error",
              message: response.message,
              color: "red",
            });
          }
        }
      })
      .catch((err) => console.error(err));
  }

  useEffect(() => {
    console.count();
    console.log("HERE IN USEEFFECT");

    /*global google */
    google.accounts.id.initialize({
      client_id:
        "934693778402-s9ihro21cvbd5h6r4t5loaf91op0l559.apps.googleusercontent.com",
      callback: handleCallbackResponse,
    });

    google.accounts.id.renderButton(document.getElementById("signInDiv"), {
      theme: "filled_blue",
      size: "large",
      shape: "rectangular",
      width: "200",
      text: "continue_with",
    });
  }, []);
  return (
    <Container maw={200}>
      {/* <Group pb="lg">
        <div
          style={{
            width: "100%",
            height: "12px",
            borderBottom: "1px solid #eaeaea",
            textAlign: "center",
          }}
        >
          <span
            className="text-dark"
            style={{
              fontSize: "16px",
              backgroundColor: "#F3F5F6",
              padding: "0 10px",

              borderRadius: "100%",
            }}
          >
            OR
          </span>
        </div>
      </Group>
       */}
      <Center>
        <h4 className="text-dark">OR</h4>
      </Center>
      {/* <Text className="text-dark" align="center" size={14}>
        Use our social sign in
      </Text> */}
      <Group position="center" id="signInDiv"></Group>
    </Container>
  );
}

export default GoogleSignIn;
